import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { MemeForm } from "../../components";
import { Card, Col, Row, Spin } from "antd";

const EditView = (props: any) => {
    const { meme, onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Memes", link: "/meme" },
                { name: "Edit", link: "" },
                { name: meme?.name, link: "" },
            ]}
        >
            <MetaTag title="Add Meme" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Meme Update"}
                        bordered={true}
                    >
                        {meme && (
                            <MemeForm
                                meme={meme}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
